export const SET_MOBILE_SIDEBAR_VIEW = 'SET_MOBILE_SIDEBAR_VIEW';

export const setMobileSidebarView = view => ({
  type: SET_MOBILE_SIDEBAR_VIEW,
  currentView: view,
});
